var _tspan;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 139",
    style: {
      stroke: "#da9b28",
      strokeWidth: 3,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 26.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "?",
    transform: "translate(20 37)",
    style: {
      fill: "#da9b28",
      fontSize: 27,
      fontFamily: "Decimal-Book,Decimal"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.4539844ad6741eb8a40fa2bf35b36be7.svg";
export { ForwardRef as ReactComponent };